import React, { PureComponent, Suspense } from 'react';
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom';
const Psychologist = React.lazy(() =>
	import('./app/psychologist/Psychologist')
);

export default class App extends PureComponent {
	render() {
		return (
			<Suspense fallback={<h1>Loading</h1>}>
				<Router>
					<Switch>
						<Route path='/' exact component={() => <h1>Home</h1>} />
						<Route
							path='/error'
							exact
							component={() => (
								<div
									style={{
										width: '100vw',
										height: '100vh',
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										textAlign: 'center',
										flexFlow: 'column',
									}}
								>
									<h1>This Page Does Not Exist</h1>
									<h2>Please check the link you have clicked.</h2>
								</div>
							)}
						/>
						<Route path='/:id' component={Psychologist} />
					</Switch>
				</Router>
			</Suspense>
		);
	}
}
